export const SaleCancelReason = {
    /** 상호 협의가 완료되지 않은 주문건 */
    NOT_YET_DISCUSSION: 'NOT_YET_DISCUSSION',
    /** 재고부족으로 인한 판매불가 */
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    /** 판매의사 변심으로 인한 거부 */
    SALE_INTENT_CHANGED: 'SALE_INTENT_CHANGED',
    /** 구매자의 미결제로 인한 거부 */
    NOT_YET_PAYMENT: 'NOT_YET_PAYMENT',
} as const
export type SaleCancelReasonType = Constant<typeof SaleCancelReason>
